import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useParams } from "react-router-dom";
import {  Link  } from "react-router-dom";
import { useSelector } from "react-redux";
// import "../Profile.css";


import contentfolder from "../../../contentImgs/folder.png";
import loadable from '@loadable/component';
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
    Trash2} from 'lucide-react';
import Loading from "../../../Loading/Loading";
import Snackbar from "../../../../Snackbar";
import LoadingButton from "../../../Loading/LoadingButton";
import ContentFolderCard from "../ContentFolderCard";
import Toggle from "../../../UI/Toggle";
import FolderForQuiz from "../Quiz/FolderForQuiz";
import { createNewMockTest } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
// import QuizSetUpOuter from "./QuizSetUpOuter";
import CustomCanvasConfetti from "../../../UI/Confetti";
import FileDropzoneUploader from "../Uploader/FileDropzoneUploader";
import { AWSFilePresignedURL, createNewLessonForCourseByAdmin } from "../../../../store/actions/CreateContent/FolderAPI/LessonAPI";
import axios from "axios";
import { re } from "mathjs";
import SpaceQuotaRechargeInfo from "./SpaceQuotaRechargeInfo";
import CreateOrderButton from "../../Payments/CreateOrderButton";
import AffordabilityWidget from "../../Payments/AffordabilityWidget";

// npm i @loadable/component 
let lazyLoad =   <Loading/>;
  ;

 const CreateLessonPopUp= ({courseId,lessonType,closeQuizPopUp,setParentFolderItem,menuOrder})=>{
    // const {category} = useParams();
   const [files, setFiles] = useState([]);

    const App = useSelector((state)=>state?.app?.app);
    const [Courses,setCourses] =useState([])
    const [CoursesBlank,setCoursesBlank] =useState([{},{},{},{},{}])
     const [animate, setAnimate] = useState(false);
     
    const dispatch = useDispatch();  
  
    const currentToken = useSelector((state)=>state?.user?.user?.token);
    const user_email = useSelector((state)=>state?.user?.user?.user_email
   );
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
   const appId = useSelector((state)=>state?.app?.app?.ID);
   const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
        
   const [snackbarVisible, setSnackbarVisible] = useState(false);
    
    const [snackbarColor, setSnackbarColor] = useState("#958FDA");
    const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
     setSnackbarVisible(true);
   };
   
    const hideSnackbar = () => {
     setSnackbarVisible(false);
   };
   const setCurrentCourse=()=>{
    dispatch({
        type: "COURSEDATA",
        
        payload:""
      });  
}
       const [loader , setLoader] =useState({status:false});
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        } 
    
        const [sellAsTestSeries, setSellAsTestSeries] = useState(false);
   
        const [folderForQuizPopUp, setFolderForQuizPopUp] = useState(false);
        const [folderForQuizPopUpCreateFolder, setFolderForQuizPopUpCreateFolder] = useState(false);
        const [parentFolder, setParentFolder] = useState({ID:""});
        
        
        const [uploadProgress, setUploadProgress] = useState(0);
        const [imageURL, setImageURL] = useState("");
        const [lessonName, setQuizName] = useState("");
        const [infoMessage, setInfoMessage] = useState("");
        const [quizID, setQuizID] = useState("");
        const [quizObject, setQuizObject] = useState({ID:""});
        const [fireConfetti, setFireConfetti] = useState(false);
        
          const [storageInfoData, setStorageInfoData] = useState({});
      
    const userdata = useSelector((state)=>state?.user?.user);
    useEffect(()=>{
      
     
     },[])
   useEffect(()=>{

    if(setParentFolderItem?.ID){
      setParentFolder(setParentFolderItem)
    }
   },[])
   function capitalize(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}
   
async function uploadWithAxiosPUT(file, presignedUrl, key, onProgress) {
  try { 
    const config = {
     headers: {
        // Content-Type should match what was used when generating presign (usually file.type)
        'Content-Type': file.type || 'application/octet-stream',
        // **Important**: include any signed headers that were used when creating the presigned URL
        // Your presigned URL earlier included x-amz-acl in signed headers, so include it:
        'x-amz-acl': 'private'
      },
      onUploadProgress: (progressEvent) => {
        // if (onProgress) {
        //   const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        //   // onProgress(percent);
        // }
      },
      timeout: 0 // optional: allow long uploads, but be careful about hanging
    };

    const response = await axios.put(presignedUrl, file, config);
    // console.log(response)
    // S3 returns 200 OK (sometimes 204). If no error thrown, upload succeeded.
    return { success: true, status: response.status, key };
  } catch (err) {
    console.error('Upload failed', err.response, err.response?.data || err.message);
    return { success: false, error: err };
  }
}
     const handleCreateNewLesson=()=>{
     
     if(!lessonName){ setResponseMessage("Lesson Name Required..");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)}
       if(!files[0]){ setResponseMessage("File Not Selected.");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)}
     if(parentFolder?.ID&&files[0]&&lessonName){
      
      setUploadProgress(10);
      setInfoMessage("")
     setLoader({status:true});
      const form = new FormData();

// append the file
form.append("file", files[0], files[0]?.name);
form.append("fileSize", files[0]?.size);

// append all other fields
form.append("lessonName", lessonName);
form.append("courseId", courseId);
form.append("postParent", parentFolder?.ID || "");
form.append("userEmail", user_email || "");
form.append("lesson_type", capitalize(lessonType));
form.append("file_type", capitalize(lessonType));

form.append("currentToken", currentToken || "");
form.append("editType", ""); 
form.append("postId", "");
form.append("menuOrder", menuOrder);
form.append("appToken", AppToken);
form.append("appId", appId);
form.append("appAllottedToken", appAllottedToken);


// then dispatch using axios (don’t wrap it inside an object, just send form directly)

 setUploadProgress("Generating key +10%");

const apiData = dispatch(AWSFilePresignedURL({file_type:lessonType,fileName:files[0]?.name,fileSize:files[0]?.size,userEmail:user_email?user_email:"",
         currentToken:currentToken?currentToken:"",courseId:courseId,
         appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}));

/* get response as Promise   */
       apiData.then(response => {
         if(response){  setUploadProgress("Uploading File +40%");

           setResponseMessage("Aws Secure Key Received");
         setSnackbarColor("rgba(144, 202, 249,1)");
      
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
     },2000)
          // getting signed url and key
          //  console.log(response)
          // setting file key to be saved in db.
          if(JSON.parse(response)?.presignedUrl) {
          form.append("fileKey", JSON.parse(response)?.key);
         // calling aws uploader from client using signed url and key
          uploadWithAxiosPUT(files[0], JSON.parse(response)?.presignedUrl, JSON.parse(response)?.key).then(response => {
            setUploadProgress("Creating Lesson +70%");
              setResponseMessage("File Uploaded To AWS");
         setSnackbarColor("rgba(144, 202, 249,1)");
      
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
     },2000)
            //  console.log(response) 
            // if successfully uploaded to aws - call create lesson api and also update key . 
const apiDatak = dispatch(createNewLessonForCourseByAdmin(form));
  apiDatak.then(response => {
    
//  console.log(response) 
if(response?.lesson){ setUploadProgress(100);
             
         setResponseMessage(response?.message);
         setSnackbarColor("rgba(144, 202, 249,1)");
      
       setFireConfetti(true) 
       setTimeout(()=>{
        setQuizObject(response?.lesson)
           setFireConfetti(false) 
            
         },3000)
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }

  }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Unable to Create Lesson...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
  
          }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Unable to upload to AWS...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
           
           
     /* resetting Login input Fields */
      }else{
        setResponseMessage(JSON.parse(response)?.message);

        setStorageInfoData(JSON.parse(response));
         setSnackbarColor("rgba(144, 202, 249,1)");
      
       setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
     },2000)
      }
        
    
    
    }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      console.log(error )
         //popup of error Info
         setResponseMessage("Signed Key Could not be returned From AWS...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      }else{
        setInfoMessage("You have not selected any folder yet.")
      }
       }
       
   
       return <>
       
   
 
  
    <div style={{position:"absolute",zIndex:"9999999999"}}>
       {fireConfetti && ( 
        <CustomCanvasConfetti AnimType="firework" />
        
        // <CustomCanvasConfetti AnimType="cannon" />
      )} 
</div>
 <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  onClick={()=>closeQuizPopUp(false)} className="appDesignPopUpOpacity" style={{zIndex:"99",cursor:"pointer"}} > </div>
        <div   className="AreYouSurePopUp" style={{borderRadius: '20px',zIndex:"100",top:"50px",bottom:"0px"}}>
           {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )}  
        <h2 align="center" style={{textTransform:"capitalize"}} >   What is the  <span className="coloredTextV1" >name of your {lessonType} lesson?</span> </h2>
      
 
<div className="bookmarkListScroll" style={{overflowY:"auto",overflowX:"hidden",}}>
  <CreateOrderButton  /> 
   <AffordabilityWidget
        keyId="rzp_test_RF23bNG4GwU54c"
        amount={100000}
      />
<h4>{infoMessage&&!parentFolder?.ID?infoMessage:""}</h4>
    <div className="">
    
  
   <div >
    
<div style={{} }>
<div  className="" >
<div  className="ikcraft_login-input-card">
 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"25px"}} placeholder={`Add ${lessonType} name`} type="text"
  rows={2} name="courseTitle" value={lessonName} onChange={(e)=>setQuizName(e.target.value)} />
 </div></div>
 
 {parentFolder?.ID?<div className=" " > 
<h3 align="center" style={{textTransform:"capitalize"}}>
  
{lessonType}   Lesson Will Be Added To This Folder
  
  </h3>
<label className={"radio-outer"}  style={{borderRadius:"5px", padding:"5px",paddingLeft:"15px",paddingTop:"8px",marginTop:"-12px",position:"relative"}}>
<div  className="courseContentItemOuterHeadActiveSettings" style={{marginTop:"0px",paddingLeft:"10px",border:"2px solid #f1f1f1" ,background:"#ffffff"}}>
<div className="courseContentItemJustifyContentIcons"  style={{borderRadius:"5px", padding:"5px",paddingLeft:"15px",paddingTop:"8px",marginTop:"2px",position:"relative"}}> 
                                    
<input type={"radio"} 
            className="input-textbox"    checked name={"quizFolderRadio"}  

/>
              <span class={"circle"}></span>                       
                                                                
             
<img     src={contentfolder} 
        alt="selected Img"
   style={{cursor:"pointer",width:"25px",height:"25px",paddingLeft:"15px",marginTop:"-7px"
    
   }}/> </div><div className="courseContentItemJustifyContent"> <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
  {parentFolder?.Name}
 
      </div></div><div  className="courseContentItemOuterHeadActiveSettingsInn"
 style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
  <div></div><div></div><div></div><div>{!setParentFolderItem?.ID?<Trash2 onClick={()=>{ setParentFolder({ID:""});;
}}  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#666666" style={{padding:"4px",background:"#ffffff",borderRadius:"5px",cursor:"pointer"}}/>:""}</div>
 </div>
 <div></div></div> </label></div>: <div className="" style={{paddingBottom:"0px",marginBottom:"0px",marginTop:"-20px"}}> 
       <div className="" style={{borderRadius:"25px",padding:"5px",}}> 
 <div >  <h2 style={{"textAlign":"center",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>  Select A Folder For  <span className="coloredTextV1" > This Lesson </span> </h2></div>
      <div className="gridFiftyFixed" style={{marginBottom:"30px"}}>
      <div align="center" onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{setFolderForQuizPopUp(true)}} 
 color="#222" style={{padding:"12px",background:"rgba(144, 202, 249,0.1)"
    ,border:"2px solid rgba(144, 202, 249,1)",width:"85%",fontWeight:"999",
    fontSize:"17px",borderRadius:"5px",color:"#222"
 ,cursor:"pointer"}}>Select
 A Folder </div>    <div align="center" onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{setFolderForQuizPopUpCreateFolder(true)}} 
 color="#222" style={{padding:"12px",background:"rgba(144, 202, 249,0.1)"
    ,border:"2px solid rgba(144, 202, 249,1)",width:"85%",fontWeight:"999",
    fontSize:"17px",borderRadius:"5px",color:"#222"
 ,cursor:"pointer"}}>Create New
  Folder </div> </div>
  </div>
  

 </div>
 
 } <img src={imageURL} /> {imageURL}
 <FileDropzoneUploader filesBack={(file)=>{setFiles(file)}} type={lessonType} />
 </div>
{folderForQuizPopUp?<FolderForQuiz  setFolderRadioItemBack={(value)=>{setParentFolder(value);setFolderForQuizPopUp(false)}} closeFolderForQuiz={()=>{setFolderForQuizPopUp(false)}}/>:""}
{folderForQuizPopUpCreateFolder?<FolderForQuiz setFolderRadioItemBack={(value)=>{setParentFolder(value);setFolderForQuizPopUpCreateFolder(false)}} setCreateNewFolderStatus={"openPopUp"} closeFolderForQuiz={()=>{setFolderForQuizPopUpCreateFolder(false)}}/>:""}

{storageInfoData?.used_space?<SpaceQuotaRechargeInfo  data={storageInfoData} closeSpaceQuotaPopUp={()=>{setStorageInfoData({})}}/>:""}

</div>





</div>

<div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"18px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>closeQuizPopUp(false)}    className=" CoursesPreviewTopBtn"  type="submit"
 > Cancel </button>
<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateNewLesson();}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > {infoMessage&&!parentFolder?.ID?" Folder not selected":<><LoadingButton  Load={loader?.status}/> {loader?.status?uploadProgress:"Click To  Create"}</>} </button>
</div> 
</div>

     </div>

     {/* {quizObject?.ID?<QuizSetUpOuter quizObject={quizObject}  setQuizObjectDataBack={(data)=>{setQuizObject(data)}} closeQuizPopUp={()=>{closeQuizPopUp(false)}}/>:""} */}
     <div>
     </div>

    
     
     </>


}
export default CreateLessonPopUp;